import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/plugins/i18n";
import FlagIcon from "vue-flag-icon";
import "./registerServiceWorker";
// Modal component
import VModal from 'vue-js-modal';
// Currency filter
import VueCurrencyFilter from 'vue-currency-filter';

Vue.use(FlagIcon);
Vue.config.productionTip = false;

Vue.use(VModal);

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'end',
  symbolSpacing: true,
});
VueCurrencyFilter.install(Vue, {
  name: 'number',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'end',
  symbolSpacing: false,
});

Vue.filter('date', function (date) {
  if (!date) return '';
  date = new Date(date);
  let m = `${date.getMonth() + 1}`;
  let d = `${date.getDate()}`;
  let y = `${date.getFullYear()}`;

  // Leading zero
  if (m.length < 2) m = `0${m}`;
  if (d.length < 2) d = `0${d}`;

  let output = [];
  output.push(d);
  output.push(m);
  output.push(y);
  return output.join('/');

})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
